// src/IT/components/AttachmentList.jsx
import React from "react";
import { downloadITAttachment } from "../../api/ITapi";

export default function AttachmentList({ attachments }) {
  const rows = attachments || [];

  return (
    <div className="it-card">
      <div className="it-card-title">Attachments</div>

      <table className="it-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Uploaded</th>
            <th>Size</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.id}>
              <td>{a.original_name}</td>
              <td>{new Date(a.uploaded_at).toLocaleString()}</td>
              <td>{a.size_bytes ? `${a.size_bytes} bytes` : "-"}</td>
              <td>
                <button
                  className="it-btn-sm"
                  onClick={() => downloadITAttachment(a.id, a.original_name)}
                >
                  Download
                </button>
              </td>
            </tr>
          ))}
          {!rows.length && (
            <tr>
              <td colSpan="4" className="it-muted">No attachments yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
